module.exports = __webpack_public_path__ + "img/about_ico3.e9349710.png";